import React from 'react'
import PropTypes from 'prop-types'
import FaqComponents from '../../components/developerApi/developerSdk/Faq/FaqComponents'

import './faqLayout.scss'

class FaqLayout extends React.Component {
    render() {
        return <div className="faq-layout">
            <h2>Frequently Asked Questions</h2>
            <FaqComponents api={this.props.api} />
        </div>
    }
}

FaqLayout.propTypes = {
    api: PropTypes.string.isRequired,
}

export default FaqLayout



// WEBPACK FOOTER //
// ./src/layouts/Faq/FaqLayout.js